<template>
  <h1>{{ msg }}</h1>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";

var data = {
  msg: "Done"
};

export default {
  name: "Done",
  data() {
    return data;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Done.vue